import {Dropdown, Space} from 'antd';
import {EllipsisOutlined} from "@ant-design/icons";
import {HumanReadableDate} from "../../../../components/DesignSystem/Moment/HumanReadableDate";

const items = [
    {
        label: 'Delete',
        key: 'delete',
    },
];

export const columns = (onMenuSelect) => [
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        ellipsis: true,
        width: 400,
        render: (text, record) => <div style={{padding: '10px'}}><a href={`/chats/${record.id}`}>{text}</a></div>
    },
    {
        title: 'Created by',
        dataIndex: 'createdBy',
        key: 'createdBy',
    },
    {
        title: 'Created at',
        dataIndex: 'createdAt',
        key: 'createdAt',
        render: (text) => <HumanReadableDate date={text}/>,
    },
    {
        title: 'Actions',
        width: 50,
        key: 'actions',
        render: (_, record) => (
            <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                <Dropdown menu={{items, onClick: () => onMenuSelect(record)}}>
                    <a onClick={e => e.preventDefault()}>
                        <Space>
                            <EllipsisOutlined/>
                        </Space>
                    </a>
                </Dropdown>
            </div>
        )
    }
];